import { render, staticRenderFns } from "./settlements.vue?vue&type=template&id=49301830&scoped=true&"
import script from "./settlements.vue?vue&type=script&lang=js&"
export * from "./settlements.vue?vue&type=script&lang=js&"
import style0 from "./settlements.vue?vue&type=style&index=0&id=49301830&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49301830",
  null
  
)

export default component.exports